import { PageRoute } from "./PageRoute";

export function GetRouteByName(name: string) {
  return mainRoutes.find((item) => item.Name === name)?.Route;
}



export const homeRoute: PageRoute = { Name: "Home", Route: "/", IsMainRoute: true };
export const chiSiamoRoute: PageRoute = {
  Name: "ChiSiamo",
  Route: "/chisiamo",
  IsMainRoute: true,
};
export const bioRoute: PageRoute = { Name: "Bio", Route: "/bio", IsMainRoute: true };
export const serviziRoute: PageRoute = {
  Name: "Servizi",
  Route: "/servizi",
  IsMainRoute: true,
};
export const contattiRoute: PageRoute = {
  Name: "Contatti",
  Route: "/contatti",
  IsMainRoute: true,
};
export const fakeRoute: PageRoute = {
  Name: "Fake",
  Route: "/fake",
  IsMainRoute: true,
};
export const sampleRoute: PageRoute = {
  Name: "Sample",
  Route: "/sample",
  IsMainRoute: true,
};
export const loStudioRoute: PageRoute = {
  Name: "LoStudio",
  Route: "/lostudio",
  IsMainRoute: true,
};

export const newsRoutes: PageRoute[] = [
  { Name: "Test1", Route: "/", IsMainRoute: true },
  { Name: "Test2", Route: "/", IsMainRoute: true },
  { Name: "Test3", Route: "/", IsMainRoute: true },
  { Name: "Test4", Route: "/", IsMainRoute: true },
];

export const mainRoutes: PageRoute[] = [
  homeRoute,
  chiSiamoRoute,
  loStudioRoute,
  bioRoute,
  serviziRoute,
  ...newsRoutes,
  contattiRoute,
];
